<ion-header>
  <ion-toolbar>
    <ion-title>Merge Users</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="merge-instructions">
    <ion-card>
      <ion-card-content>
        <p>
          Select the <strong>Source User</strong> that will be deleted and
          transferred to <strong>Target User</strong>.
        </p>
        <p class="warning-text">
          <ion-icon name="warning" color="danger"></ion-icon>
          <strong>This action cannot be undone!</strong>
        </p>
      </ion-card-content>
    </ion-card>
  </div>

  <div class="selection-section">
    <ion-card>
      <ion-card-header>
        <ion-card-title
          >Step 1: Select Source User (will be deleted)</ion-card-title
        >
      </ion-card-header>
      <ion-card-content>
        <div class="user-selection-row">
          <div class="selected-user" *ngIf="selectedSourceUser">
            <ion-chip color="danger">
              <ion-icon name="arrow-forward-outline"></ion-icon>
              <ion-label>{{ formatUserName(selectedSourceUser) }}</ion-label>
            </ion-chip>
            <ion-button fill="clear" size="small" (click)="clearSourceUser()">
              <ion-icon name="close-outline"></ion-icon>
            </ion-button>
          </div>
          <ion-button
            *ngIf="!selectedSourceUser"
            fill="outline"
            (click)="selectSourceUser($event)"
          >
            <ion-icon name="person-add-outline" slot="start"></ion-icon>
            Select Source User
          </ion-button>
        </div>
        <p *ngIf="!selectedSourceUser" class="instruction-text">
          Choose user to delete
        </p>
      </ion-card-content>
    </ion-card>

    <ion-card>
      <ion-card-header>
        <ion-card-title
          >Step 2: Select Target User (will receive data)</ion-card-title
        >
      </ion-card-header>
      <ion-card-content>
        <div class="user-selection-row">
          <div class="selected-user" *ngIf="selectedTargetUser">
            <ion-chip color="success">
              <ion-icon name="checkmark-outline"></ion-icon>
              <ion-label>{{ formatUserName(selectedTargetUser) }}</ion-label>
            </ion-chip>
            <ion-button fill="clear" size="small" (click)="clearTargetUser()">
              <ion-icon name="close-outline"></ion-icon>
            </ion-button>
          </div>
          <ion-button
            *ngIf="!selectedTargetUser"
            fill="outline"
            (click)="selectTargetUser($event)"
            [disabled]="!selectedSourceUser"
          >
            <ion-icon name="person-add-outline" slot="start"></ion-icon>
            Select Target User
          </ion-button>
        </div>
        <p *ngIf="!selectedTargetUser" class="instruction-text">
          <span *ngIf="!selectedSourceUser">Select source user first</span>
          <span *ngIf="selectedSourceUser && !selectedTargetUser">
            Choose user to keep
            <span *ngIf="selectedSourceUser.isExternal">(External only)</span>
            <span *ngIf="!selectedSourceUser.isExternal">(Internal only)</span>
          </span>
        </p>
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <div class="footer-content">
      <div
        class="merge-summary"
        *ngIf="selectedSourceUser && selectedTargetUser"
      >
        <p class="summary-text">
          <strong>{{ selectedSourceUser.name }}</strong> →
          <strong>{{ selectedTargetUser.name }}</strong>
        </p>
      </div>

      <div class="footer-buttons">
        <ion-button fill="clear" (click)="dismiss()" [disabled]="isSubmitting">
          Cancel
        </ion-button>

        <ion-button
          color="danger"
          (click)="confirmMerge()"
          [disabled]="!canSubmit()"
        >
          <ion-spinner *ngIf="isSubmitting" name="crescent"></ion-spinner>
          <span *ngIf="!isSubmitting">Merge Users</span>
          <span *ngIf="isSubmitting">Merging...</span>
        </ion-button>
      </div>
    </div>
  </ion-toolbar>
</ion-footer>
